/**
 * 英语
 */
export default {
  route: {
    dashboard: {
      _name: 'Dashboard',
      workplace: {_name: 'Workplace'},
      analysis: {_name: 'Analysis'},
      monitor: {_name: 'Monitor'}
    },
    system: {
      _name: 'Account Management',
      admin: {
        _name: 'Administrators',
        info: {_name: ''}
      },
      finance: {
        _name: 'Financial Accounts',
        info: {_name: ''}
      },
      role: {_name: 'Roles'},
      user: {
        _name: 'User Management',
        info: {_name: ''}
      },
      menu: {_name: 'Menu'},
      dictionary: {_name: 'Dictionary'},
      organization: {_name: 'Organization'},
      loginRecord: {_name: 'LoginRecord'},
      operRecord: {_name: 'OperRecord'}
    },

    resource: {
      _name: 'resource',
      class: {_name: 'Resource Grouping'},
      recolumn: {_name: 'Bank Card Management'},
    },

    wallet: {
      _name: 'Wallet Center',
      currency: {_name: 'Currency Management'},
      transmodel: {_name: 'Trading Models'},
    },

    config: {
      _name: 'System Setup',
      website: {_name: 'System Setup'},
    },

    balance: {
      _name: 'Amount adjustment',
      index: {_name: 'Amount adjustment'},
    },

    channel: {
      _name: 'Channel Management',
      type: {_name: 'Channel Type'},
      balance: {_name: 'Channel Balance'},
      column: {_name: 'Sub-channel List'},
    },

    transaction: {
      _name: 'Transaction Management',
      inorder: {_name: 'Payment Order'},
      inlist: {_name: 'Payment Confirmation'},
      outorder: {_name: 'Transfer orders'},
      records: {_name: 'Order Record'},
    },

    reconciliation: {
      _name: 'Reconciliation Management',
      bussiness: {_name: 'User Reconciliation'},
      channel: {_name: 'Channel Reconciliation'},
      model: {_name: 'Peer-to-Peer Reconciliation'},
      shouyi: {_name: 'Company Profit'},
    },

    tool: {
      _name: 'System Tools',
      generate: {_name: 'Code Generation'},
    },

    form: {
      _name: 'Form',
      bausernamesic: {_name: 'Basic Form'},
      advanced: {_name: 'Advanced Form'},
      step: {_name: 'Step Form'}
    },
    list: {
      _name: 'List',
      basic: {_name: 'Basic List'},
      advanced: {_name: 'Advanced List'},
      card: {
        _name: 'Card List',
        project: {_name: 'Project'},
        application: {_name: 'Application'},
        article: {_name: 'Article'}
      }
    },
    result: {
      _name: 'Result',
      success: {_name: 'Success'},
      fail: {_name: 'Fail'}
    },
    exception: {
      _name: 'Exception',
      '403': {_name: '403'},
      '404': {_name: '404'},
      '500': {_name: '500'}
    },
    user: {
      _name: 'User',
      profile: {_name: 'Profile'},
      message: {_name: 'Message'}
    },
    extension: {
      _name: 'Extension',
      icon: {_name: 'Icon'},
      file: {_name: 'File'},
      printer: {_name: 'Printer'},
      excel: {_name: 'Excel'},
      dragsort: {_name: 'DragSort'},
      map: {_name: 'Map'},
      player: {_name: 'Player'},
      editor: {_name: 'Editor'},
      more: {_name: 'More'}
    },
    example: {
      _name: 'Example',
      document: {_name: 'Document'},
      choose: {_name: 'Choose'},
    },
    'http://www.xxx.com': {_name: 'Authorization'}
  },
  layout: {
    home: 'Home',
    header: {
      profile: 'Profile',
      password: 'Password',
      logout: 'SignOut'
    },
    footer: {
      website: 'Website',
      document: 'Document',
      authorization: 'Authorization',
      copyright: 'Copyright © 2021 NanJing RXThinkCMF R & D Center'
    },
    logout: {
      title: 'Confirm',
      message: 'Are you sure you want to log out?'
    }
  },
  login: {
    title: 'Admin background - login',
    username: 'please input username',
    password: 'please input password',
    captcha: 'please input code',
    remember: 'remember',
    forget: 'forget',
    login: 'login',
    loading: 'loading'
  },

  // 通用
  universal:{
    startingtime:"Starting Time",
    endtime:"EndTime",
    pleasechoose:"PleaseSelect",
    pleaseenter:"PleaseEnter",
    recognize: "Recognize",
    inquire:"Inquire",
    reset:"Reset",
    export:"Export",
    turnon:"Open",
    closure:"Close",
    yes:"yes",
    no:"no",
    unknown: 'unknown',
    success: 'success',
    retreat: 'retreat',
    abnormal: 'abnormal',
    cancel: 'cancel',
  },
  // 首页
  home:{
    totalbalance:"balance (accountancy)",
    availablebalance:"Available Balance",
    freezebalance:"Amount frozen",
    unsettledamount:"Unliquidated balances",
  },
  // 清理数据
  cleandata:{
    selecttime:"SelectTime",
    selectdata:"SelectData",
    option1:"[ All Data ] | Choose carefully, you can't recover after deletion.",
    option2:"[ Collection Data ] | Choose carefully, it can't be recovered after deletion.",
    option3:"[ Disbursement Data ] | Choose carefully, you can't recover after deletion.",
    option4:"[ Account Change Data ] | Choose carefully, you can't recover after deletion.",
    warnings: "Tip: Please delete carefully, you can not recover after the operation.",
  },
   // 订单列表
   orderlist:{
    username:"Name",
    userorder:"User",
    systemorder:"System",
    transactiontype:"Type",
    channelorder:"Channel",
    tradingstatus:"Status",
    transactionaccountchanges:"Details",
    selectionperiod:"Time",
  },
  // 头部统计
  statistics:{
    today_success:"[Success today]:",
    today_receipt:"[Collect today]:",
    unknown_orders:" [Unknown order]:",
    unknown_amount:" [Unknown amount]:",
    service_fee:" [Handling fee]:",
    order_rate:" [Order rate]:",
  }
}
